<template>
  <footer class="footer">
    <!-- <div class="footer-container">
        <div class="footer-column brand" style="min-width:37%" >
          <h2 class="brand-title">SodaSoft.io</h2>
          <p class="brand-description">
            Modern, web-based tools that help automotive dealerships manage, surface, and promote inventory effectively.
          </p>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">Product</h3>
          <ul>
            <li><a href="#">Features</a></li>
            <li><a href="#">Pricing</a></li>
            <li><a href="#">Integrations</a></li>
            <li><a href="#">Updates</a></li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">Resources</h3>
          <ul>
            <li><a href="#">Documentation</a></li>
            <li><a href="#">API Reference</a></li>
            <li><a href="#">Guides</a></li>
            <li><a href="#">Support</a></li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">Company</h3>
          <ul>
            <li><a href="#">About</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Careers</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>
      </div> -->

    <div class="footer-bottom-1">
      <div class="footer-bottom">
        <p>© Jazel Automotive. All rights reserved.</p>
        <div class="footer-links">
          <!-- <a style="font-size: 14px;" href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Contact Support</a> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background-color: #ffffff;
  padding: 0px 30px 20px;
  font-family: 'Inter', sans-serif;
  color: #475569;
  font-size: 14px;
  /* border-top: 1px solid #e5e7eb; */
}

.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 40px;
  max-width: 1340px;
  margin: 0 auto;
}

.footer-column {
  flex: 1 1 200px;
  min-width: 150px;
}

.brand-title {
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
}

.brand-description {
  margin-top: 8px;
  color: #64748b;
  line-height: 1.6;
  max-width: 300px;
}

.footer-heading {
  font-weight: 600;
  margin-bottom: 10px;
  color: #0f172a;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li a {
  color: #64748b;
  text-decoration: none;
  display: block;
  margin-bottom: 8px;
  transition: color 0.2s;
}

li a:hover {
  color: #1d4ed8;
}
.footer-bottom-1 {
  /* margin-top: 40px; */
  border-top: 1px solid #e5e7eb;
  padding-top: 20px;
}
.footer-bottom {
  justify-content: space-between;
  max-width: 1340px;
  margin: auto;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  color: #64748b;
}

.footer-links {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-links a {
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #1d4ed8;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    gap: 30px;
  }

  .footer-bottom {
    align-items: center;
    display: block;
  }
  .footer-links {
    justify-content: space-between;
    gap: 10px;
  }
  .footer-links > a {
    font-size: 12px;
  }
}
</style>
